import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms'
import { Subscription, interval } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { IDatePickerConfig } from 'ng2-date-picker';

declare var $: any;
declare function unescape(p: any);

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.css']
})
export class TestComponent implements OnInit, OnDestroy {

  datePickerConfig: IDatePickerConfig = {
    format: 'DD-MM-YYYY'
  }

  datePickerConfig1: IDatePickerConfig = {
    format: 'YYYY-MM-DD'
  }

  rbiEdfData: any = [];
  cn22 = ''
  canExec = true
  cn23 = ''

  cn22Bill = ''
  cn23Bill = ''

  selectedDocketNo: any = '';
  selectedDocStatus: any = '';
  desc = ''
  self: any;
  selectedDoc: any = {};
  message = '';
  remark = 'Please Select';
  vl = 'filter';
  goodsLength;
  actualPbe1 = '';
  editedIbm: any = ''
  fpo = 'all'
  cnt = [];
  today;
  dd;
  mm;
  yyyy;
  sdrValue = null;
  actualPbe2 = '';
  searchInput = '';
  searchType = 'iec'
  search = 'all';
  isSearch = false;
  searchQuery = '';
  isLoading = false;
  isAll = false;
  parcelLength: '';
  trackingData;
  pageSize = 20;
  allPbeCount;
  docketNo: any;
  pages = Array(50).fill(1).map((x, i) => i);
  pageNo = 1;
  private allItems: any[];
  boxData: any = [];
  form: FormGroup;
  docs: any = [];
  // pager object
  pager: any = {};
  categoryOfExporter1 = '1'
  modeOfRealisation1 = 'L/C'
  natureOfContract1 = '1'
  exporterDeclaration1 = 'already realized by debit/credit card'
  currency: any;
  // paged items
  pagedItems: any[];
  selectedAll: any;
  selectedBoxIdsForPBE = [];
  checkClicked: boolean = false;
  selectedInvoice;
  fileName: any;
  isCn22: boolean = false;
  isCn23: boolean = false;
  isCn22Bill: boolean = false;
  isCn23Bill: boolean = false;
  selectedInvoices: any = [];
  edfData: any = [];
  isData = false;
  isAllowedbtn: boolean = true;
  private subs: Subscription;
  private source = interval(1000 * 60);
  private subscribe: Subscription;
  dateSubs: Subscription;

  constructor(public authService: AuthService, public location: Location, public router: Router, public fb: FormBuilder) { }

  ngOnInit() {
    this.listenForSocketResponse();
    this.getCurrencies();
    this.createForm();
    var d = JSON.parse(localStorage.getItem("data"));
    this.selectedDocketNo = d["docketNo"];
    this.selectedDocStatus = d['docStatus'];
    this.checkDocumentStatus(this.selectedDocketNo);

  }

  ngOnDestroy() {
    this.canExec = false;
    if (this.subs) {
      this.subs.unsubscribe();
    }

    if (this.subscribe) {
      this.subscribe.unsubscribe();
    }

    if (this.dateSubs) {
      this.dateSubs.unsubscribe();
    }
  }

  /******************* */




  listenForSocketResponse() {
    this.subs = this.authService.getListenObs().subscribe(result => {
      // // console.log("result >>> ", result);
      if (result.success && this.selectedDocketNo == result.docketNo) {
        this.cureentpbe["isAllInvoicesGen"] = 'Generated';
        // // console.log("yes its true >> ", this.selectedDoc);
        // this.isAllowedbtn = true;
      }
    });
  }

  /******************* */

  downloadAllInvoices(docketNo, type) {

    if (type == 'download') {
      let url = this.authService.domain + 'downloadZip/' + docketNo;
      // // console.log("download url >>>> ", url);
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.href = url;
      a.target = "_blank"
      a.click()
    }
    else {
      this.authService.generateInvoicesInBulk(docketNo, this.cureentpbe.exporterDetails.ieCode).subscribe(res => {
        if (res.success) {
          this.selectedDoc.isAllInvoicesGen = "Processing";
        }
        this.authService.showAlert(res.message);
        this.authService.setListenObs(false, '');

        this.subscribeTimer();
        this.isAllowedbtn = false;
      });
    }
  }

  subscribeTimer() {
    this.subscribe = this.source.subscribe(val => {
      this.isAllowedbtn = true;
      // // console.log("Generate btn enabled ? >>> ", this.isAllowedbtn);

      if (this.subscribe) {
        this.subscribe.unsubscribe();
      }
    });
  }

  createForm() {

    this.form = this.fb.group({
      rbiApprovalNo: [''],
      rbiApprovalDate: [''],
      categoryOfExporter: [''],
      modeOfRealisation: ['L/C'],
      natureOfContract: [''],
      exporterDeclaration: [''],
      formNo: [''],
      thirdPartyName: [""],
      thirdPartyAddress: [""],
      freightAmountForeign: ['0'],
      freightAmountInr: ['0'],
      freightCurrency: ['0'],
      freightExchangeRate: ['0'],
      insuranceAmountForeign: ['0'],
      insuranceAmountInr: ['0'],
      commissionAmountForeign: ['0'],
      commissionAmountInr: ['0'],
      discountAmountForeign: ['0'],
      discountAmountInr: ['0'],
      deductionAmountForeign: ['0'],
      deductionAmountInr: ['0'],
      packingAmountForeign: ['0'],
      packingAmountInr: ['0'],
      receiptDate: [''],
      receiptNumber: [''],
      acuPayment: ['Yes']
    })
  }

  getCurrencies() {
    this.authService.getCurrencies().subscribe((res) => {
      if (res.success) {
        if (res.data.length != 0) {
          this.currency = [];
          for (var i = 0; i < res.data.length; i++) {
            var obj = { label: res.data[i].name, value: res.data[i].short, price: res.data[i].value }
            this.currency.push(obj)
          }
        }
      }
    })
  }

  closeTracking() {
    $('body').removeAttr('style')
  }

  uploadEditedIbm(type, id) {
    this.isLoading = true
    this.authService.postReq('lookup/uploadibmFile', this.editedIbm).subscribe((res) => {
      this.isLoading = false
      this.authService.showAlert(res.message);
      if (res.success) {
        this.selectedDoc.updatedIbm = this.selectedDoc.tempSBill + '.xls'
      }
    })
  }

  downloadIbm() {
    this.isLoading = true
    this.authService.postReq('lookup/downloadibmfile', { docketNo: this.selectedDoc.docketNo }).subscribe((response) => {
      this.isLoading = false
      if (response.success == true) {
        const blob = new Blob([new Uint8Array(response.link.data)])
        var objectUrl = URL.createObjectURL(blob);
        this.JSONToCSVConvertor(objectUrl);
      }
      else {
        // swal('Oops !', response.message, 'error');
        this.authService.showAlert(response.message)
      }
    })
  }

  checkDocumentStatus(selectedDocketNo) {
    var obj = { docketNo: selectedDocketNo }
    this.authService.checkDocumentStatus(obj).subscribe(res => {
      this.getCurrentPBEdetails();
      if (res.success == true) {
        this.selectedDoc = res.data;
        // // console.log("this.selectedDoc >>> ", this.selectedDoc);
        // if (this.selectedDoc.isAllInvoicesGen != 'Generated') {
        //   setTimeout(() => {
        //     this.checkDocumentStatus(this.selectedDocketNo)
        //   }, 10000);
        // }
      }
    })
  }



  postalCSI(bill) {
    this.authService.generateCSI({ tempSBill: bill }).subscribe(response => {
      if (response.success == true) {
        const blob = new Blob([new Uint8Array(response.link.data)])
        var objectUrl = URL.createObjectURL(blob);
        this.JSONToCSVConvertor(objectUrl);
      }
      else {
        // swal('Oops !', response.message, 'error');
        this.authService.showAlert(response.message)
      }
    })
  }

  JSONToCSVConvertor(url) {
    var a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    this.today = new Date();
    this.dd = this.today.getDate();
    this.mm = this.today.getMonth() + 1; //January is 0!
    this.yyyy = this.today.getFullYear();

    if (this.dd < 10) {
      this.dd = '0' + this.dd;
      this.today = this.dd + '-' + this.mm + '-' + this.yyyy;
    }

    if (this.mm < 10) {
      this.mm = '0' + this.mm;
      this.today = this.dd + '-' + this.mm + '-' + this.yyyy;
    }


    // // console.log(this.today);
    a.download = 'PIKMYBOX_' + this.today + ".xls";
    a.click();
    window.URL.revokeObjectURL(url);
  }

  setValuecategoryOfExporter1(val) {
    this.categoryOfExporter1 = val;
  }

  printOrder(e, t, p) {


    this.isLoading = true
    if (t == 'pbe' || t == 'edf' || t == 'postal') {
      this.authService.downloadAsPdf({ tempSBill: e, type: t, boxId: e }).subscribe(data => {
        const blob = new Blob([new Uint8Array(data.link.data)], { type: "application/pdf" })
        var url = URL.createObjectURL(blob);
        this.isLoading = false
        if (p == 'view') {
          window.open(url, '_blank')
        }
        else {
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.href = url;
          this.today = new Date();
          this.dd = this.today.getDate();
          this.mm = this.today.getMonth() + 1; //January is 0!
          this.yyyy = this.today.getFullYear();

          if (this.dd < 10) {
            this.dd = '0' + this.dd;
            this.today = this.dd + '-' + this.mm + '-' + this.yyyy;
          }

          if (this.mm < 10) {
            this.mm = '0' + this.mm;
            this.today = this.dd + '-' + this.mm + '-' + this.yyyy;
          }
          a.download = this.selectedDocketNo + this.today + ".pdf";
          a.click();
          window.URL.revokeObjectURL(url);
        }
      })
    }
    else if (t == 'authorityLetter' || t == 'checklist' || t == 'pickupPackingList') {
      this.authService.postReq('lookup/downloadpickupDoc', { type: t, docketNo: e }).subscribe((res) => {
        this.isLoading = false
        if (res.success) {
          var myWindow = window.open('', '', 'width=800,height=1000');
          myWindow.document.write(res.data);
          myWindow.focus();

        }
        else {
          this.authService.showAlert(res.message)
        }
      })
    }
    else {
      this.authService.getdatabybox({ boxId: e }).subscribe(data => {
        this.isLoading = false
        if (data.success) {
          // // console.log(data)
          var multipleRow = ''
          if (data.result.length != 0) {
            var boxD = data.result[0];
            var gw = 0;
            var tv = 0;
            var r = 6;
            gw = gw + Number(data.result[0].grossWeight) / 1000;
            for (var g = 0; g < data.result.length; g++) {
              var ds = data.result[g];
              tv = tv + Number(ds.fob_foreign);
              r = r + 1
              if (data.result.length > 1 && g == 0) {
                multipleRow = '<tr> <td colspan="3"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> &nbsp;&nbsp;&nbsp;&nbsp; <br><br><br><br></span> </td> <td colspan="2"> <span style="margin: 0;font-size: 9px;font-weight: 700;">  &nbsp;&nbsp; &nbsp;&nbsp;  </span> </td> <td colspan="2"> <span style="margin: 0;font-size: 9px;font-weight: 700;">  &nbsp;&nbsp; &nbsp;&nbsp;  </span> </td> <td colspan="2"> <span style="margin: 0;font-size: 9px;font-weight: 700;">  &nbsp;&nbsp; &nbsp;&nbsp;  </span> </td> <td colspan="3"> <span style="margin: 0;font-size: 9px;font-weight: 700;">  &nbsp;&nbsp; &nbsp;&nbsp;  </span> </td> <td colspan="1"> <span style="margin: 0;font-size: 9px;font-weight: 700;">  &nbsp;&nbsp; INDIA  </span> </td> </tr>'
              }
              else if (data.result.length == 1 && g == 0) {
                if (g == 0) {
                  multipleRow = '<tr> <td colspan="3"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> &nbsp;&nbsp; ' + ds.description + '  </span> </td> <td colspan="2"> <span style="margin: 0;font-size: 9px;font-weight: 700;">  &nbsp;&nbsp; ' + ds.quantity.number + '  </span> </td> <td colspan="2"> <span style="margin: 0;font-size: 9px;font-weight: 700;">  &nbsp;&nbsp; ' + ds.weight / 1000 + '  </span> </td> <td colspan="2"> <span style="margin: 0;font-size: 9px;font-weight: 700;">  &nbsp;&nbsp; ' + ds.fob_foreign + '  </span> </td> <td colspan="3"> <span style="margin: 0;font-size: 9px;font-weight: 700;">  &nbsp;&nbsp; ' + ds.hsnCode + '  </span> </td> <td colspan="1"> <span style="margin: 0;font-size: 9px;font-weight: 700;">  &nbsp;&nbsp; INDIA  </span> </td> </tr>'
                }
                else {
                  multipleRow += '<tr> <td colspan="3"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> &nbsp;&nbsp; ' + ds.description + '</span> </td> <td colspan="2"> <span style="margin: 0;font-size: 9px;font-weight: 700;">  &nbsp;&nbsp; ' + ds.quantity.number + '  </span> </td> <td colspan="2"> <span style="margin: 0;font-size: 9px;font-weight: 700;">  &nbsp;&nbsp; ' + ds.weight / 1000 + '  </span> </td> <td colspan="2"> <span style="margin: 0;font-size: 9px;font-weight: 700;">  &nbsp;&nbsp; ' + ds.fob_foreign + '  </span> </td> <td colspan="3"> <span style="margin: 0;font-size: 9px;font-weight: 700;">  &nbsp;&nbsp; ' + ds.hsnCode + '  </span> </td> <td colspan="1"> <span style="margin: 0;font-size: 9px;font-weight: 700;">  &nbsp;&nbsp; INDIA  </span> </td> </tr>'
                }
              }
              // if (g == 0) {
              //   multipleRow = '<tr> <td colspan="3"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> &nbsp;&nbsp; ' + ds.description + '  </span> </td> <td colspan="2"> <span style="margin: 0;font-size: 9px;font-weight: 700;">  &nbsp;&nbsp; ' + ds.quantity.number + '  </span> </td> <td colspan="2"> <span style="margin: 0;font-size: 9px;font-weight: 700;">  &nbsp;&nbsp; ' + ds.weight / 1000 + '  </span> </td> <td colspan="2"> <span style="margin: 0;font-size: 9px;font-weight: 700;">  &nbsp;&nbsp; ' + ds.fob_foreign + '  </span> </td> <td colspan="3"> <span style="margin: 0;font-size: 9px;font-weight: 700;">  &nbsp;&nbsp; ' + ds.hsnCode + '  </span> </td> <td colspan="1"> <span style="margin: 0;font-size: 9px;font-weight: 700;">  &nbsp;&nbsp; INDIA  </span> </td> </tr>'
              // }
              // else {
              //   multipleRow += '<tr> <td colspan="3"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> &nbsp;&nbsp; ' + ds.description + '</span> </td> <td colspan="2"> <span style="margin: 0;font-size: 9px;font-weight: 700;">  &nbsp;&nbsp; ' + ds.quantity.number + '  </span> </td> <td colspan="2"> <span style="margin: 0;font-size: 9px;font-weight: 700;">  &nbsp;&nbsp; ' + ds.weight / 1000 + '  </span> </td> <td colspan="2"> <span style="margin: 0;font-size: 9px;font-weight: 700;">  &nbsp;&nbsp; ' + ds.fob_foreign + '  </span> </td> <td colspan="3"> <span style="margin: 0;font-size: 9px;font-weight: 700;">  &nbsp;&nbsp; ' + ds.hsnCode + '  </span> </td> <td colspan="1"> <span style="margin: 0;font-size: 9px;font-weight: 700;">  &nbsp;&nbsp; INDIA  </span> </td> </tr>'
              // }
            }
            var p = '<html> <head> </head> <style> table.details { border: 2px solid #000; width: 100% } .pi_heading { text-align: center } .logo_heading { width: 100% } .logo_heading img { height: 30px } .logo_com img { float: left } .logo_prod img { float: right; margin-right: 40px; transform: scale(1.8); } .lg { width: 100%; padding: 20px } .logo_com { width: 50% } body { padding-left: 15%; padding-right: 15% } .pi_heading2 { text-align: left } table.details { border-collapse: collapse; border: 2px solid black; } .logo_prod, .logo_com { width: 50%; } .pi_heading h5 { line-height: 30px; margin: 0px; font-size: 20px; } table.details th, table.details td { border: 1px solid black; } .pi_heading1>td { padding: 3px; font-family: Roboto, Helvetica, Arial, sans-serif; } .pi_heading1>td>h5 { margin: 0px; } .pi_heading1>td>p { margin: 0px; } .pi_heading1 td h4 { text-align: center } @media print { .lg { width: 100% } body { padding-left: 0%; padding-right: 0%; font-family: "Georgia"; width: 210mm; height: 146mm; } table.details { border: 2px solid #000; width: 100%; border-collapse: collapse; } .pi_heading { text-align: center } .pi_heading1>td { padding: 4px; font-family: Roboto, Helvetica, Arial, sans-serif; } .pi_heading h5 { line-height: 30px; margin: 0px; font-size: 20px; } .pi_heading h4 { text-align: left } .pi_heading1>td>h4 { text-align: left; } .pi_heading1>td>h4 { margin: 0px; } .pi_heading2 { text-align: left } .logo_heading { width: 100% } .logo_heading img { height: 30px } .logo_com img { float: left } .logo_prod img { float: right; margin-right: 40px; transform: scale(1.8); } .logo_prod, .logo_com { width: 50% } /* table.details { } */ table.details th, table.details td { border: 1px solid black; } .pi_heading1>td>p { margin: 0px; } .pi_heading1>td.order_row { width: 33.33333%; } @page { size: 210mm 146mm; } } table.details { border: 2px solid #000; width: 100% } .pi_heading { text-align: center } .logo_heading { width: 100% } .logo_heading img { height: 30px } .logo_com img { float: left } .logo_prod img { float: right; margin-right: 40px; transform: scale(1.8); } .lg { width: 100%; padding: 20px } .logo_com { width: 50% } body { padding-left: 15%; padding-right: 15% } .pi_heading2 { text-align: left } table.details { border-collapse: collapse; border: 2px solid black; } .logo_prod, .logo_com { width: 50%; } .pi_heading h5 { line-height: 30px; margin: 0px; font-size: 20px; } table.details th, table.details td { border: 1px solid black; } .pi_heading1>td { padding: 3px; font-family: Roboto, Helvetica, Arial, sans-serif; } .pi_heading1>td>h5 { margin: 0px; } .pi_heading1>td>p { margin: 0px; } .pi_heading1 td h4 { text-align: center } .pi_heading h4 { text-align: left } .pi_heading1>td>h4 { text-align: left; } body { width: 210mm; height: 146mm; } @page { size: 210mm 146mm } </style> <body> <div style="width: 210mm; height: 146mm; margin: auto; overflow: hidden;padding: 0px"> <table class="details" style="width: 210mm; height: 146mm; margin: auto; overflow: hidden;padding: 0px"> <tbody> <tr class="pi_heading1"> <td colspan="10" style="text-align: left ;"> <span style="margin: 0;font-size: 11px;font-weight: 700;"> Designated operator </span> </td> <td colspan="2" style="text-align: center" rowspan="7"> <span style="margin: 0;font-size: 11px;font-weight: 700;"> CUSTOMS DECLARATION  No. of item (Barcode, if any) </span>     </td> <td colspan="1" style="text-align: center" rowspan="7"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> I May be opend officially </span>      </td> <td colspan="1" style="text-align: center" rowspan="7"> <h2 style="text-align: center"> CN 23 </h2>  <span style="margin: 0;font-size: 9px;font-weight: 700;"> Important see  instruction on the back </span>   </td> </tr> <tr class="pi_heading1"> <td colspan="1" rowspan="5"> <span style="margin: 0;font-size: 11px;font-weight: 700;"> From </span> </td> <td colspan="5"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Name &nbsp;&nbsp; ' + boxD.exporterDetails.name + ' </span> </td> <td colspan="4" rowspan="2" style="text-align: center">  <span style="margin: 0;font-size: 9px;font-weight: 700;"> Sender Customs Referance if any </span> </td> </tr> <tr class="pi_heading1"> <td colspan="5"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Business &nbsp;&nbsp; ' + boxD.exporterDetails.name + '</span> </td> </tr> <tr class="pi_heading1"> <td colspan="3"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Street &nbsp;&nbsp; ' + boxD.exporterDetails.address + '</span> </td> <td colspan="6"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Tel No. &nbsp;&nbsp; </span> </td> </tr> <tr class="pi_heading1"> <td colspan="3"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Postalcode &nbsp;&nbsp;  ' + boxD.exporterDetails.pin + '</span> </td> <td colspan="6"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> City &nbsp;&nbsp;  ' + boxD.exporterDetails.city + '</span> </td> </tr> <tr class="pi_heading1"> <td colspan="9"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Country &nbsp;&nbsp; INDIA</span> </td> </tr> <tr class="pi_heading1"> <td colspan="1" rowspan="5"> <span style="margin: 0;font-size: 11px;font-weight: 700;">To</span> </td> <td colspan="9"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Name &nbsp;&nbsp; ' + boxD.consigneeDetails.name + '</span> </td> </tr> <tr class="pi_heading1"> <td colspan="9"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Business &nbsp;&nbsp; </span> </td> <td colspan="4" rowspan="2"> <span style="margin: 0;font-size: 8px;font-weight: 700;">   Importers reference (If any) (Tax code Vat No. /Importer Code) (optional) </span> </td> </tr> <tr class="pi_heading1"> <td colspan="3"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Street &nbsp;&nbsp; ' + boxD.consigneeDetails.address + '</span> </td> <td colspan="6"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Tel No. &nbsp;&nbsp; ' + boxD.consigneeDetails.mobile + '</span> </td> </tr> <tr class="pi_heading1"> <td colspan="3"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Postalcode &nbsp;&nbsp; ' + boxD.consigneeDetails.zipCode + '</span> </td> <td colspan="6"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> City &nbsp;&nbsp; </span> </td> <td colspan="4" rowspan="2"> <span style="margin: 0;font-size: 8px;font-weight: 700;">   Importers address Tel/Fax/e-mail (If Know) </span> </td> </tr> <tr class="pi_heading1"> <td colspan="9"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Country &nbsp;&nbsp; ' + boxD.consigneeDetails.country + '</span> </td> </tr> <tr class="pi_heading1"> <td colspan="1" rowspan="7"> </td> <td colspan="3" rowspan="2"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Detailed description of contents (1) </span> </td> <td colspan="2" rowspan="2"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Quantity (2) </span> </td> <td colspan="2" rowspan="2"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Net Weight (in kg) (3) </span> </td> <td colspan="2" rowspan="2"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Value (5) </span> </td> <td colspan="4"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> For commercial use only </span> </td> </tr> <tr class="pi_heading1"> <td colspan="3"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> HS tariff number (7) </span> </td> <td colspan="2"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Country of origin of goods (8) </span> </td> </tr> ' + multipleRow + ' <tr> <td colspan="3"> <span style="margin: 0;font-size: 9px;font-weight: 700;">   </span> </td> <td colspan="2"> <span style="margin: 0;font-size: 9px;font-weight: 700;">   </span> </td> <td colspan="2"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Total Gross Weight (4)   &nbsp;&nbsp;' + gw.toFixed(4) + '  </span> </td> <td colspan="2"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Total Value (6)   &nbsp;&nbsp; ' + tv.toFixed(2) + '  </span> </td> <td colspan="3"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Postal charges/Fees (9)    </span> </td> <td colspan="1"> <span style="margin: 0;font-size: 9px;font-weight: 700;">   </span> </td> </tr> <tr> <td colspan="3"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Category of Item (10) Gift Documents  </span> </td> <td colspan="4"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Commercial Sample Return Goods   </span> <span style="margin: 0;font-size: 9px;font-weight: 700;line-height: 15px"> Sale of Goods &nbsp; &nbsp; &nbsp; </span> <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfiBR8KAChv4PW8AAAAd0lEQVQ4y+3UsRGCQBhE4U/LwYQKDM8eaMBSqIFKbgyxB5s4ivgNNCCRuWMMeZvuC3eBJCtiI0WWfBk3q+uMnCQPPE1efnNxd8WNLMxqmIVMEYYqYRAKIfRVQi/Euaq64hAO4X/Cgq6q22FpHtCOiTaewIeGm3kDwG1rB+a5nnUAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDUtMzFUMTA6MDA6NDArMDI6MDCzDhlnAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTA1LTMxVDEwOjAwOjQwKzAyOjAwwlOh2wAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII=" alt="" style="height: 15px;"> </td> <td colspan="4"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Other Explanation   </span> <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfiBR8KAChv4PW8AAAAd0lEQVQ4y+3UsRGCQBhE4U/LwYQKDM8eaMBSqIFKbgyxB5s4ivgNNCCRuWMMeZvuC3eBJCtiI0WWfBk3q+uMnCQPPE1efnNxd8WNLMxqmIVMEYYqYRAKIfRVQi/Euaq64hAO4X/Cgq6q22FpHtCOiTaewIeGm3kDwG1rB+a5nnUAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDUtMzFUMTA6MDA6NDArMDI6MDCzDhlnAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTA1LTMxVDEwOjAwOjQwKzAyOjAwwlOh2wAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII=" alt="" style="height: 15px;"> </td> <td colspan="3"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Office of origin /Date of Posting </span> </td> </tr> <tr class="pi_heading1"> <td colspan="9" style="text-align: center"> <span style="margin: 0;font-size: 8px;font-weight: 700;"> Comments (11) (e.g. goods subject to quarantine, sanitary/phyosanitary inspection or other restrictions) </span> </td> <td colspan="4" style="text-align: center"> <span style="margin: 0;font-size: 8px;font-weight: 700;">   I certfy that the particulars given in this customs declartion are  correct and that this item does not contain any dangerous articles  prohibited by legislation or by posts or customs regulations   </span> </td> </tr> <tr> <td colspan="3" style="text-align: center"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Licence (12)   </span><br> <span style="margin: 0;font-size: 9px;font-weight: 700;line-height: 15px"> No. (s) of licence (s) </span> <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfiBR8KAChv4PW8AAAAd0lEQVQ4y+3UsRGCQBhE4U/LwYQKDM8eaMBSqIFKbgyxB5s4ivgNNCCRuWMMeZvuC3eBJCtiI0WWfBk3q+uMnCQPPE1efnNxd8WNLMxqmIVMEYYqYRAKIfRVQi/Euaq64hAO4X/Cgq6q22FpHtCOiTaewIeGm3kDwG1rB+a5nnUAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDUtMzFUMTA6MDA6NDArMDI6MDCzDhlnAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTA1LTMxVDEwOjAwOjQwKzAyOjAwwlOh2wAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII=" alt="" style="height: 15px;"> </td> <td colspan="4" style="text-align: center"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Certificate (13)   </span><br>  <span style="margin: 0;font-size: 9px;font-weight: 700;line-height: 15px"> No. (s) of certificate (s) </span> <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfiBR8KAChv4PW8AAAAd0lEQVQ4y+3UsRGCQBhE4U/LwYQKDM8eaMBSqIFKbgyxB5s4ivgNNCCRuWMMeZvuC3eBJCtiI0WWfBk3q+uMnCQPPE1efnNxd8WNLMxqmIVMEYYqYRAKIfRVQi/Euaq64hAO4X/Cgq6q22FpHtCOiTaewIeGm3kDwG1rB+a5nnUAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDUtMzFUMTA6MDA6NDArMDI6MDCzDhlnAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTA1LTMxVDEwOjAwOjQwKzAyOjAwwlOh2wAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII=" alt="" style="height: 15px;"> </td> <td colspan="4" style="text-align: center"> <span style="margin: 0;font-size: 9px;font-weight: 700;"> Invoice (13)<br>   No.(s) Invoice(s)  </span> <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfiBR8KAChv4PW8AAAAd0lEQVQ4y+3UsRGCQBhE4U/LwYQKDM8eaMBSqIFKbgyxB5s4ivgNNCCRuWMMeZvuC3eBJCtiI0WWfBk3q+uMnCQPPE1efnNxd8WNLMxqmIVMEYYqYRAKIfRVQi/Euaq64hAO4X/Cgq6q22FpHtCOiTaewIeGm3kDwG1rB+a5nnUAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDUtMzFUMTA6MDA6NDArMDI6MDCzDhlnAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTA1LTMxVDEwOjAwOjQwKzAyOjAwwlOh2wAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII=" alt="" style="height: 15px;"> </td> <td colspan="3"> <span style="margin: 0;font-size: 9px;font-weight: 700;">   Office of origin /Date of Posting </span> </td> </tr> </tbody> </table> </div> </body> </html>'
            var myWindow = window.open('', '', 'width=800,height=1000');
            myWindow.document.write(p);
            myWindow.focus();
            if (p != 'pre') {

            }
          }

        }
      })
    }

  }

  public restrictNumeric(e) {
    let input;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
      return false;
    }
    if (e.which === 0) {
      return true;
    }
    if (e.which < 33) {
      return true;
    }
    input = String.fromCharCode(e.which);
    // return !!/[\d\s]/.test(input);
    return !!/[\d\.\s]/.test(input);
  }

  printallcnform(id) {
    this.isLoading = true
    this.docketNo = id;

    var obj = {
      tempSBill: id
    }
    this.authService.printallcnform(obj).subscribe(data => {
      if (data.success) {

        this.isLoading = false;
        if (data.cn22 != undefined && data.cn23 != undefined) {
          this.cn22 = data.cn22;
          this.cn23 = data.cn23;
          this.isCn22 = true;
          this.isCn23 = true;
          // $('#uploadDocuments').modal('hide');
          // $('#cnModal').modal('show');
        }

        else if (data.cn22) {
          this.isCn22 = false;
          this.isCn23 = false;
          var myWindow = window.open('', '', 'width=800,height=1000');
          myWindow.document.write(data.cn22);
          myWindow.focus();
          myWindow.focus();

        }

        else {
          this.isCn22 = false;
          this.isCn23 = false;
          var myWindow = window.open('', '', 'width=800,height=1000');
          myWindow.document.write(data.cn23);
          myWindow.focus();
          myWindow.focus();

        }
      }

      else {
        this.isCn22 = false;
        this.isCn23 = false;
        // swal('Error', 'Unable to generate CN 22 Form', 'error')
        this.authService.showAlert("Unable to generate CN 22 Form")
      }
    })
  }

  categoryOfItem = 'Sales of Goods'

  m = new Date().getMonth() + 1
  mnth = (this.m != 10 && this.m != 11) ? '0' + this.m : this.m
  mailingDate = new Date().getFullYear() + '-' + this.mnth + '-' + new Date().getDate()
  generateHarmonizedLabel(id) {
    // console.log("id >> ", id, this.selectedDoc);

    this.isLoading = true
    this.docketNo = id;

    var obj = {
      tempSBill: id,
      categoryOfItem: this.categoryOfItem,
      mailingDate: this.mailingDate,
      harmonizedCountries: this.harmonizedCountryArr.map((x) => x.country)
    }
    this.authService.generateHarmonizedLabel(obj).subscribe(data => {
      if (data.success) {


        this.categoryOfItem = 'Sales of Goods'
        this.mailingDate = new Date().getFullYear() + '-' + this.mnth + '-' + new Date().getDate()
        $('#harmonize').modal('hide')


        this.isLoading = false;
        if (data.cn22 != undefined && data.cn23 != undefined) {
          // $('#uploadDocuments').modal('hide');
          // $('#cnModal').modal('show');
        }

        // else if (data.cn22) {
        var myWindow = window.open('', '', 'width=800,height=1000');
        myWindow.document.write(data.cn22);
        myWindow.focus();
        myWindow.focus();



      }

      else {
        this.authService.showAlert("Unable to generate harmonized label")
      }
    })
  }

  printallcnformWithShippingLabel(id, isNew) {
    this.isLoading = true
    this.docketNo = ''
    this.docketNo = id;

    var obj = {
      tempSBill: id,
      withLabelName: isNew // ship to : block
    }
    this.authService.printallcnformWithShippingLabel(obj).subscribe(data => {
      if (data.success) {

        this.isLoading = false;
        if (data.cn22 != undefined && data.cn23 != undefined) {
          this.cn22Bill = data.cn22;
          this.cn23Bill = data.cn23;
          this.isCn22Bill = true;
          this.isCn23Bill = true;
          // $('#uploadDocuments').modal('hide');
          // $('#cnModal').modal('show');
        }

        else if (data.cn22) {
          this.isCn22Bill = false;
          this.isCn23Bill = false;
          var myWindow = window.open('', '', 'width=800,height=1000');
          myWindow.document.write(data.cn22);
          myWindow.focus();
          myWindow.focus();

        }

        else {
          this.isCn22Bill = false;
          this.isCn23Bill = false;
          var myWindow = window.open('', '', 'width=800,height=1000');
          myWindow.document.write(data.cn23);
          myWindow.focus();
          myWindow.focus();

        }
      }
      else {
        this.isLoading = false;
        this.isCn22Bill = false;
        this.isCn23Bill = false;
        // swal('Error', 'Unable to generate CN 22 Form', 'error')
        // this.authService.showAlert("Unable to generate CN 22 Form")
        this.authService.showAlert(data.message)
      }
    })
  }



  printallcn2223form(type) {
    if (type == '22') {

      $('#cnModal').modal('hide');
      var myWindow = window.open('', '', 'width=800,height=1000');
      myWindow.document.write(this.cn22);
      myWindow.focus();
      myWindow.focus();

    }
    else {
      $('#cnModal').modal('hide');
      var myWindow = window.open('', '', 'width=800,height=1000');
      myWindow.document.write(this.cn23);
      myWindow.focus();
      myWindow.focus();

    }
  }

  printallcn2223formWithShippingBill(type) {
    if (type == '22') {

      $('#cnModal').modal('hide');
      var myWindow = window.open('', '', 'width=800,height=1000');
      myWindow.document.write(this.cn22Bill);
      myWindow.focus();
      myWindow.focus();

    }
    else {
      $('#cnModal').modal('hide');
      var myWindow = window.open('', '', 'width=800,height=1000');
      myWindow.document.write(this.cn23Bill);
      myWindow.focus();
      myWindow.focus();

    }
  }

  printallshippinglabels(sBill, isNew) {
    this.isLoading = true;
    var obj = {
      tempSBill: sBill,
      withLabelName: isNew // ship to : block
    }

    this.authService.printallshippinglabels(obj).subscribe(data => {
      if (data.success) {
        this.isLoading = false;
        var myWindow = window.open('', '', 'width=800,height=1000');
        myWindow.document.write(data.html);
        myWindow.focus();
        myWindow.focus();
        setTimeout(() => {
          myWindow.print();
        }, 1000)

      }
      else {
        // swal('Error', data.message, 'error')
        this.authService.showAlert(data.message)
      }
    })
  }


  printallcpform(id) {
    this.isLoading = true
    var obj = {
      tempSBill: id
    }
    this.authService.printallcpform(obj).subscribe(data => {
      if (data.success) {

        this.isLoading = false;
        var myWindow = window.open('', '', 'width=800,height=1000');
        myWindow.document.write(data.cp);
        myWindow.focus();


      }
      else {
        this.isLoading = false
        // swal('Error', data.message, 'error')
        this.authService.showAlert(data.message)
      }

    })
  }


  changeListener1($event): void {

    this.readThis1($event.target);

  }
  changeListener($event): void {

    this.readThis($event.target);

  }

  readThis(inputValue: any): void {

    this.docs = [];
    for (var i = 0; i < inputValue.files.length; i++) {
      this.getBase64(inputValue.files[i]);
    }
  }

  getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.docs.push({ fileName: file.name, fileType: file.type, base64: reader.result });
    };
    reader.onerror = function (error) {
      // // console.log('Error: ', error);
    };
  }


  readThis1(inputValue: any): void {

    this.docs = [];
    for (var i = 0; i < inputValue.files.length; i++) {
      this.getBase1(inputValue.files[i]);
    }
  }

  getBase1(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    this.fileName = file.name;
    reader.onload = () => {
      this.editedIbm = { docketNo: this.selectedDoc.docketNo, fileName: file.name, fileType: file.type, base64: reader.result };
    };
    reader.onerror = function (error) {
      // // console.log('Error: ', error);
    };
  }

  sendFiles(name, id) {
    if (this.desc.trim().length >= 5) {
      if (this.docs.length > 0) {
        var obj = { docketNo: this.selectedDocketNo, type: name, files: this.docs, desc: this.desc }
        this.authService.eVerifiedUpload(obj).subscribe(response => {

          if (response.success == true) {
            this.checkDocumentStatus(this.selectedDocketNo);
            this.docs = [];
            (<HTMLInputElement>document.getElementById(id)).value = "";
            this.desc = ''
            // swal('Success!', response.message, 'success');
            this.authService.showAlert(response.message)
            // $('#uploadDocuments').modal('hide');

          }
          else {
            // swal('Oops !!', response.message, 'error');
            this.authService.showAlert(response.message)
          }
        })
      }
      else {
        // swal('', 'Please Select a File to Upload', 'info');
        this.authService.showAlert('Please Select a File to Upload.')
      }
    }
    else {
      // swal('', 'Please enter some description for file.', 'info');
      this.authService.showAlert('Please enter some description for file.')
    }

  }


  viewDoc(id) {
    this.authService.viewDoc({ fileName: id }).subscribe(res => {
      if (res.success == true) {
        const blob = new Blob([new Uint8Array(res.link.data)], { type: "application/pdf" })
        var url = URL.createObjectURL(blob);
        this.isLoading = false
        window.open(url, '_blank')
      }
    });

  }

  deletedocument(type, filename, docketNo) {
    var obj = { docketNo: docketNo, fileName: filename, type: type }
    this.authService.deletedocument(obj).subscribe(response => {

      if (response.success == true) {
        this.checkDocumentStatus(this.selectedDocketNo);
        this.docs = [];
        // swal('success', response.message, 'success');
        this.authService.showAlert(response.message)
        // $('#uploadDocuments').modal('hide');
      }
      else {
        // swal('Oops !!', response.message, 'error');
        this.authService.showAlert(response.message)
      }

    })
  }



  selectInvoice(e, state) {
    this.selectedInvoice = e;
    this.isAll = state;
  }

  selectedOrderForBox(val) {
    this.checkRbiEdf(this.selectedDocketNo);
  }

  checkDuplicate(v) {
    var k = '';
    if (this.cnt.indexOf(v) > -1) {
      return false
    }
    else {
      this.cnt.push(v);
      return true
    }
  }

  submitEdf(formValue) {

    var obj: any;

    obj = formValue;
    obj.isData = this.isData;
    if (obj.rbiApprovalDate == '' || obj.rbiApprovalDate == null || obj.rbiApprovalDate == undefined) {
      obj.rbiApprovalDate = '';
    }

    if (obj.receiptDate == '' || obj.receiptDate == null || obj.receiptDate == undefined) {
      obj.receiptDate = '';
    }


    this.authService.saveEdfData({
      edfDetails: obj, isData: this.isData, tempSBill: this.selectedDocketNo,
      invoiceNo: this.selectedInvoice, isAll: this.isAll, invoices: this.selectedInvoices
    }).subscribe(data => {
      if (data.success) {
        this.form.reset();

        this.categoryOfExporter1 = '1'
        this.modeOfRealisation1 = 'L/C'
        this.natureOfContract1 = '1'
        this.exporterDeclaration1 = 'Already realized by debit/credit card'
        this.selectedOrderForBox(this.selectedDocketNo);

        $('#detailModal').modal('show');
        this.selectedInvoices = [];
        // swal('Success', data.message, 'success')
        this.authService.showAlert(data.message)
      }
      else {
        // swal('Error', data.message, 'error')
        this.authService.showAlert(data.message)
      }
    });
  }

  selectBoxIds(e, id) {
    if (e.target.checked) {
      if (!this.selectedInvoices.includes(id)) {
        this.selectedInvoices.push(id);
      }
    }
    else {
      var ind = this.selectedInvoices.indexOf(id);
      if (ind > -1) {
        this.selectedInvoices.splice(ind, 1);
      }
    }
  }


  functiontofindIndexByKeyValue(arraytosearch, key, valuetosearch) {
    for (var i = 0; i < arraytosearch.length; i++) {
      if (arraytosearch[i][key] == valuetosearch) {
        // // console.log(i);
        return i;
      }
    }
    return -1;
  }


  selectAll(e) {
    if (e.target.checked) {
      for (var i = 0; i < this.boxData.length; i++) {
        for (var j = 0; j < this.boxData[i].newInv.length; j++) {
          //  // console.log(this.selectedInvoices.includes(this.boxData[i].newInv[j].isEdf));
          if (this.boxData[i].newInv[j].isEdf) {
            if (!this.selectedInvoices.includes(this.boxData[i].newInv[j].invoice)) {
              this.selectedInvoices.push(this.boxData[i].newInv[j].invoice);
            }
          }
        }
      }
    }
    else {
      this.selectedInvoices = [];
    }
  }

  getedfdataforpbe(val) {
    // // console.log("val >> ", val);

    var isUpdate = false;
    if (val == "update") {
      isUpdate = true;
    }

    if (this.isAll) {
      isUpdate = false;
    }

    this.authService.getedfdataforpbe({
      tempSBill: this.selectedDocketNo, isUpdate: isUpdate,
      invoiceNo: this.selectedInvoice
    }).subscribe(response => {
      if (response.success && response.data) {
        if (val == "update") {
          this.dataUpdate(response);
        }
        else {
          this.isData = true;
          let {
            rbiApprovalNo, categoryOfExporter, modeOfRealisation,
            natureOfContract, exporterDeclaration, thirdPartyName,
            thirdPartyAddress, acuPayment, receiptNumber, formNo,
            receiptDate, rbiApprovalDate
          } = response.data.edfDetails;

          let rd = receiptDate ? receiptDate.split('T')[0] : '';
          let rad = rbiApprovalDate ? rbiApprovalDate.split('T')[0] : '';

          this.form.patchValue({
            rbiApprovalNo, categoryOfExporter, modeOfRealisation,
            natureOfContract, exporterDeclaration, thirdPartyName,
            thirdPartyAddress, acuPayment, receiptNumber, formNo,
            receiptDate: rd, rbiApprovalDate: rad
          });

        }
      }
      else {
        this.categoryOfExporter1 = '1'
        this.modeOfRealisation1 = 'L/C'
        this.natureOfContract1 = '1'
        this.exporterDeclaration1 = 'already realized by debit/credit card'
        this.authService.showAlert(response.error);
      }
    });
  }

  dataUpdate(response) {
    let { rbiApprovalNo, categoryOfExporter, modeOfRealisation,
      natureOfContract, exporterDeclaration, thirdPartyName,
      thirdPartyAddress, acuPayment, receiptNumber, formNo,
      receiptDate, rbiApprovalDate, freightAmountForeign, insuranceAmountForeign,
      commissionAmountForeign, discountAmountForeign, packingAmountForeign, deductionAmountForeign, } = response.data.edfDetails;

    let rd = receiptDate ? receiptDate.split('T')[0] : '';
    let rad = rbiApprovalDate ? rbiApprovalDate.split('T')[0] : '';

    this.form.patchValue({
      rbiApprovalNo, categoryOfExporter, modeOfRealisation,
      natureOfContract, exporterDeclaration, thirdPartyName,
      thirdPartyAddress, acuPayment, receiptNumber, formNo,
      receiptDate: rd, rbiApprovalDate: rad,
      freightAmountForeign, insuranceAmountForeign,
      commissionAmountForeign, discountAmountForeign,
      packingAmountForeign, deductionAmountForeign
    });

    this.getCategory(categoryOfExporter);
    this.getNatureOfContract(natureOfContract);
  }

  getCategory(v) {
    if (v == 'Custom (DTA units)' || v == '1') {
      this.categoryOfExporter1 = '1'
    }
    else if (v == 'SEZ' || v == '2') {
      this.categoryOfExporter1 = '2'
    }
    else if (v == 'Status holder exporters' || v == '3') {
      this.categoryOfExporter1 = '3'
    }
    else if (v == '100% EOU' || v == '4') {
      this.categoryOfExporter1 = '4'
    }
    else if (v == 'Warehouse Export' || v == '5') {
      this.categoryOfExporter1 = '5'
    }
    else {
      this.categoryOfExporter1 = '6'
    }
  }

  getNatureOfContract(v) {
    if (v == 'FOB' || v == '1') {
      this.natureOfContract1 = '1'
    }
    else if (v == 'CIF' || v == '2') {
      this.natureOfContract1 = '2'
    }
    else if (v == 'C&F' || v == '3') {
      this.natureOfContract1 = '3'
    }
    else if (v == 'CI' || v == '4') {
      this.natureOfContract1 = '4'
    }
    else {
      this.natureOfContract1 = '5'
    }
  }

  mailDocs(docketNo) {
    this.authService.sendDocViaEmail({ docketNo: docketNo }).subscribe(response => {
      if (response.success == true) {
        // swal('Ok',response.message,'success');
        this.authService.showAlert(response.message)

      }
      else {
        // swal('Oops !',response.error,'success');
        this.authService.showAlert(response.message)

      }
    })
  }

  checkSelected(id) {
    var ind = this.selectedInvoices.indexOf(id);
    if (ind > -1) {
      return true
    }
    else {
      return false
    }
  }

  checkRbiEdf(docketNo) {
    this.authService.checkRbiEdf({ tempSBill: docketNo }).subscribe(response => {
      if (response.success == true) {
        this.rbiEdfData = response.data;
        this.boxData = [];
        this.form.reset();
        this.authService.getdataforboxbypbe({ tempSBill: docketNo }).subscribe(d => {

          this.cnt = [];
          this.boxData = d.data;
          // // console.log(this.boxData);
          var f = '';
          var m = [];
          for (var i = 0; i < this.boxData.length; i++) {
            for (var j = 0; j < this.boxData[i].invoices.length; j++) {
              if (j == 0) {
                f = this.boxData[i].invoices[j];
                this.boxData[i].newInv = [{ invoice: this.boxData[i].invoices[j], isEdfDetails: this.isRbiEdf(this.boxData[i].invoices[j]) }]
              }
              else {
                if (f != this.boxData[i].invoices[j]) {
                  this.boxData[i].newInv.push({ invoice: this.boxData[i].invoices[j], isEdfDetails: this.isRbiEdf(this.boxData[i].invoices[j]) })
                }
              }
            }
          }
          for (var r = 0; r < this.boxData.length; r++) {
            for (var t = 0; t < this.boxData[r].newInv.length; t++) {
              this.boxData[r].newInv[t].isEdf = this.checkDuplicate(this.boxData[r].newInv[t].invoice)
            }
          }
        })

        this.selectedBoxIdsForPBE = [];
        // // console.log(this.boxData);
      }
      else {
        // swal("Oops!",response.message,'error');
        this.authService.showAlert(response.message)
      }
    })
  }

  isRbiEdf(invoiceNo) {
    var data = this.rbiEdfData.filter(item => item.invoiceNo == invoiceNo);
    let dd = (data.length > 0) ? data[0].isEdfDetails : false;
    return dd;
  }

  checkEdf() {
    var data = this.rbiEdfData.filter(item => item.isEdfDetails == true);
    if (data.length > 0) {
      return true;
    }
    return false
  }

  trackShipment(e) {
    $("#fluidModalBottomDangerDemo").modal();
    this.trackingData = '<h5><i class="fa fa-spinner fa-spin text-primary" style="font-size:30px" ></i>&nbsp; Please wait while we get tracking information for ' + e + '</h5>'
    this.authService.trackshipment({ trackingId: e }).subscribe(d => {
      if (d.success) {
        if (unescape(d.data) == null || unescape(d.data) == 'null' || unescape(d.data) == '') {
          this.trackingData = 'No tracking info. available for tracking Id <b>' + e + '</b>'
        }
        else {
          this.trackingData = '<h5 class="text-center">' + e
            + '</h5><table class="table table-striped table-bordered trackTbl"><thead><tr><th class="text-center">Date & Time</th><th class="text-center">Country</th><th class="text-center">Location</th><th class="text-center">Event</th><th class="text-center">Mail Category</th><th class="text-center">Next Office</th><th class="text-center" colspan="2">Extra Information</th><tbody>'
            + unescape(d.data) + '</tbody></table>';
        }
      }
      else {
        // swal('Error', d.message, 'error')
        this.authService.showAlert(d.message)
      }
    })
  }

  viewSummary() {
    this.isLoading = true
    var obj = { tempSBill: this.selectedDocketNo, isDownload: true }
    this.authService.viewpbesummary(obj).subscribe(response => {
      if (response.success == true) {
        const blob = new Blob([new Uint8Array(response.link.data)], { type: "application/pdf" })
        var url = URL.createObjectURL(blob);
        window.open(url, '_blank')
      }
      else {
        // swal('error', response.message, 'error');
        this.authService.showAlert(response.message)
      };
      this.isLoading = false
    })
  }

  ii = 0
  harmonizedCountryArr = []
  harmonizedCountries() {
    this.authService.harmonizedCountries({}).subscribe(response => {
      if (response.success == true) {
        this.harmonizedCountryArr = response.data;
        if (this.cureentpbe && this.cureentpbe.country.length && this.harmonizedCountryArr.length) {
          this.harmonizedCountryArr.map((x) => { if (this.cureentpbe.country.includes(x.country)) { this.ii++ } })
        } else {
          this.ii = 0
        }
        // // console.log(this.ii)
      } else {
        this.ii = 0
        this.harmonizedCountryArr = [];
      }
      this.isLoading = false;
    });
  }

  cureentpbe;
  getCurrentPBEdetails() {
    this.isLoading = true;
    this.authService.getCurrentPBEdetails({ docket: this.selectedDocketNo }).subscribe(response => {
      if (response.success == true) {
        this.cureentpbe = response.data;
        this.harmonizedCountries()
      } else {
        this.cureentpbe = {}
      }
      this.isLoading = false;
    })
  }

  parcelType() {
    if (this.cureentpbe.parcelType == "Int'l Tracked Packets") {
      return true
    } else {
      return false
    }
  }


}

